import { aroFetch } from "../aroApi";
import { Certificate, CertificateListItem, CertificateListResponse, CertificateSearchParams } from "../../types/aro";

export async function fetchCertificates(params: CertificateSearchParams): Promise<CertificateListResponse> {
  const qs = new URLSearchParams();
  if (params.person_id)                                                qs.set("person_id",           params.person_id);
  if (params.person_name)                                              qs.set("person_name",          params.person_name);
  if (params.person_email)                                             qs.set("person_email",         params.person_email);
  if (params.event_id)                                                 qs.set("event_id",             params.event_id);
  if (params.certificate_name)                                         qs.set("certificate_name",    params.certificate_name);
  if (params.certificate_type && params.certificate_type !== "all")    qs.set("certificate_type",    params.certificate_type);
  if (params.tracking_status  && params.tracking_status  !== "all")    qs.set("tracking_status",     params.tracking_status);
  if (params.tracking_status_reason && params.tracking_status_reason !== "all") qs.set("tracking_status_reason", params.tracking_status_reason);
  qs.set("limit",  String(params.limit  ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<CertificateListResponse>(`/api/certificates?${qs.toString()}`);
}

export async function fetchCertificateById(id: string | number): Promise<CertificateListItem> {
  return aroFetch<CertificateListItem>(`/api/certificates/${id}`);
}

export interface CertificatePatch {
  changed_by:               string;
  certificate_name?:        string;
  external_cert_id?:        string | null;
  certificate_earned_date?: string;
  company_at_time?:         string | null;
  baseline_company?:        string | null;
  baseline_company_url?:    string | null;
  changed_company?:         string | null;
  changed_company_url?:     string | null;
  tracking_end_date?:       string;
  next_snapshot_due?:       string | null;
  tracking_status?:         "active" | "paused" | "job_changed" | "stopped";
  tracking_status_reason?:  string | null;
  event_id?:                string | null;
}

export async function updateCertificate(cert_id: string | number, body: CertificatePatch): Promise<Certificate> {
  return aroFetch<Certificate>(`/api/certificates/${cert_id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
